<!-- user.component.html -->

<!-- Bouton utilisateur -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions"
    aria-label="User menu"
>
    <div class="relative w-8 h-8 rounded-full overflow-hidden">
        @if (showAvatar) { @if (userProfile()?.avatar) {
        <img
            class="w-8 h-8 rounded-full"
            [ngSrc]="userProfile().avatar"
            alt="Avatar utilisateur"
            width="32"
            height="32"
        />
        } @else {
        <div
            class="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-on-primary"
        >
            <span class="font-semibold text-sm">
                {{ userProfile()?.first_name?.charAt(0)
                }}{{ userProfile()?.last_name?.charAt(0) }}
            </span>
        </div>
        } } @else {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </div>
    <!-- Indicateur de statut -->
    @if (userProfile()?.status) {
    <span
        class="absolute right-1 bottom-0 w-2 h-2 rounded-full ring-2 ring-white"
        [ngClass]="{
            'bg-green-500': userProfile().status === 'ONLINE',
            'bg-amber-500': userProfile().status === 'AWAY',
            'bg-red-500': userProfile().status === 'BUSY',
            'bg-gray-400': userProfile().status === 'OFFLINE'
        }"
    >
    </span>
    }
</button>

<!-- Menu utilisateur -->
<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <!-- Salutation de l'utilisateur -->
    <button mat-menu-item class="w-full justify-center">
        @if (userProfile()?.last_name) {
        <div class="text-center leading-none text-base font-medium">
            {{ "USER_MENU.GREET" | transloco }}
            <span class="text-primary font-bold">{{
                userProfile().last_name
            }}</span>
        </div>
        }
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- Paramètres -->
    <button
        mat-menu-item
        [routerLink]="['/parametre']"
        routerLinkActive="router-link-active"
    >
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>{{ "USER_MENU.SETTINGS" | transloco }}</span>
    </button>

    <!-- Statut de l'utilisateur -->
    <button mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon
            [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
        ></mat-icon>
        <span>{{ "USER_MENU.STATUS" | transloco }}</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- Menu des langues avec support des pays francophones -->
    <button mat-menu-item [matMenuTriggerFor]="languages">
        @let lang = activeLang(); @let flags = getFlagsForLanguage(lang);
        <div class="flex items-center">
            <div class="flex items-center mr-2">
                 <!-- Drapeau du pays francophone si applicable -->
                @if (flags.country) {
                <span
                    class="relative w-6 shadow rounded-sm overflow-hidden mr-1"
                >
                    <span
                        class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
                    ></span>
                    <img
                        class="w-full"
                        width="150"
                        height="100"
                        [ngSrc]="
                            'assets/images/flags/' +
                            flags.country.toUpperCase() +
                            '.svg'
                        "
                        [alt]="
                            'Country flag for ' + userProfile()?.club?.country
                        "
                    />
                </span>
                }
                <!-- Drapeau principal de la langue -->
                <span class="relative w-6 shadow rounded-sm overflow-hidden">
                    <span
                        class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
                    ></span>
                    <img
                        class="w-full"
                        width="150"
                        height="100"
                        [ngSrc]="
                            'assets/images/flags/' +
                            flags.main.toUpperCase() +
                            '.svg'
                        "
                        [alt]="'Flag image for ' + lang"
                    />
                </span>

               
            </div>
            <span>{{ "USER_MENU.LANGUAGE" | transloco }}</span>
        </div>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- Suppression de compte -->
    <button
        mat-menu-item
        (click)="onDeleteAccount()"
        class="text-red-600 hover:bg-red-50"
    >
        <mat-icon
            [svgIcon]="'heroicons_outline:trash'"
            class="text-red-600"
        ></mat-icon>
        <span>{{ "USER_MENU.DELETE_ACCOUNT" | transloco }}</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- Déconnexion -->
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>{{ "USER_MENU.LOGOUT" | transloco }}</span>
    </button>
</mat-menu>

<!-- Menu de statut utilisateur -->
<mat-menu #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('ONLINE')">
        <div class="flex items-center">
            <div class="w-3 h-3 rounded-full bg-green-500 mr-3"></div>
            <span>{{ "USER_MENU.ONLINE" | transloco }}</span>
        </div>
    </button>
    <button mat-menu-item (click)="updateUserStatus('AWAY')">
        <div class="flex items-center">
            <div class="w-3 h-3 rounded-full bg-amber-500 mr-3"></div>
            <span>{{ "USER_MENU.AWAY" | transloco }}</span>
        </div>
    </button>
    <button mat-menu-item (click)="updateUserStatus('BUSY')">
        <div class="flex items-center">
            <div class="w-3 h-3 rounded-full bg-red-500 mr-3"></div>
            <span>{{ "USER_MENU.BUSY" | transloco }}</span>
        </div>
    </button>
    <button mat-menu-item (click)="updateUserStatus('OFFLINE')">
        <div class="flex items-center">
            <div class="w-3 h-3 rounded-full bg-gray-400 mr-3"></div>
            <span>{{ "USER_MENU.OFFLINE" | transloco }}</span>
        </div>
    </button>
</mat-menu>

<!-- Menu des langues -->
<mat-menu [xPosition]="'before'" #languages="matMenu">
    @for (lang of availableLangs(); track $index) { @let flags =
    getFlagsForLanguage(lang.id);
    <button mat-menu-item (click)="setActiveLang(lang.id)">
        <span class="flex items-center">
            <div class="flex items-center">

                   <!-- Drapeau du pays francophone si applicable (uniquement pour le français et si pays francophone) -->
                @if (lang.id === 'fr' && countryFlagForFrench()) { @let
                countryFlag = countryFlagForFrench(); @if (countryFlag) {
                <span
                    class="relative w-6 shadow rounded-sm overflow-hidden mr-1"
                >
                    <span
                        class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
                    ></span>
                    @defer (on viewport) {
                    <img
                        class="w-full"
                        width="133"
                        height="100"
                        [ngSrc]="
                            'assets/images/flags/' +
                            countryFlag.toUpperCase() +
                            '.svg'
                        "
                        [alt]="
                            'Country flag for ' + userProfile()?.club?.country
                        "
                    />
                    } @placeholder {
                    <div class="w-6 h-4 bg-gray-200"></div>
                    }
                </span>
                } }

                <!-- Drapeau principal de la langue -->
                <span class="relative w-6 shadow rounded-sm overflow-hidden">
                    <span
                        class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
                    ></span>
                    @defer (on viewport) {
                    <img
                        class="w-full"
                        width="133"
                        height="100"
                        [ngSrc]="
                            'assets/images/flags/' +
                            flags.main.toUpperCase() +
                            '.svg'
                        "
                        [alt]="'Flag image for ' + lang.id"
                    />
                    } @placeholder {
                    <div class="w-6 h-4 bg-gray-200"></div>
                    }
                </span>
            </div>
            <span class="ml-3">{{ lang.label }}</span>
        </span>
    </button>
    }
</mat-menu>
